import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLessons } from "@/react/components/Spaces/CourseSpace/Lessons/Edit/hooks/useLessons";
import { LessonFile } from "@/react/components/Spaces/CourseSpace/Shared/LessonFile";
import { useModalData } from "@circle-react-uikit/ModalV2";
import {
  SortableList,
  useListItemDataProvider,
} from "@circle-react-uikit/SortableList";

const FileItem = ({ shouldShowCheckmark }) => {
  const { item: file } = useListItemDataProvider();
  return (
    <LessonFile
      file={file}
      isDraggable
      shouldShowDropdown
      shouldShowCheckmark={shouldShowCheckmark}
    />
  );
};

FileItem.propTypes = {
  shouldShowCheckmark: PropTypes.bool,
};

export const Content = ({ files, completedUploads }) => {
  const { updateFilesOrder } = useLessons({ forEdition: false });
  const { contentPortalElement } = useModalData();
  const [orderedFiles, setOrderedFiles] = useState(files);

  useEffect(() => {
    setOrderedFiles(files);
  }, [files]);

  const onSort = newOrder => {
    setOrderedFiles(newOrder);
    updateFilesOrder({
      filesOrder: newOrder.map(file => file.id.toString()),
    });
  };

  if (!files) {
    return null;
  }

  return (
    <div className="border-primary border-t">
      <div className="-mx-6 mt-2">
        <SortableList
          items={orderedFiles}
          onSort={onSort}
          lockedVerticalAxis
          distance={10}
        >
          <SortableList.List gap={0}>
            {orderedFiles.map(file => (
              <SortableList.Item key={file.id} item={file} className="h-16">
                <FileItem
                  shouldShowCheckmark={completedUploads.includes(
                    file.signed_id,
                  )}
                />
              </SortableList.Item>
            ))}
          </SortableList.List>
          <SortableList.DragOverlay portalTo={contentPortalElement}>
            <FileItem />
          </SortableList.DragOverlay>
        </SortableList>
      </div>
    </div>
  );
};

Content.propTypes = {
  files: PropTypes.array.isRequired,
  completedUploads: PropTypes.array,
};
